module.exports = __webpack_public_path__ + "static/media/flagged-black.bb6c9895.svg";